export default __webpack_public_path__ + "assets/pdf/GexproCreditApplication.b630c3a3.pdf";